<template>
  <el-drawer :visible.sync="vis" :close-on-click-modal="false" id="orderDetails">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="order">
        <template slot="label"><i class="el-icon-document" style="margin-right:4px"></i>订单详情</template>
        <div class="formTitle">
          {{ order.orderNo }} / {{ order.status | filterOrderStatus }}
        </div>
        <div class="box">
          <div class="item">
            <span class="title">线路名称</span>
            <span class="value">{{ order.startStationName }} - {{ order.endStationName }}</span>
          </div>
          <div class="item">
            <span class="title">车票价格</span>
            <span class="value" style="color: #ff9900; font-weight: bold">￥{{ order.lineFee }}</span>
          </div>
          <div class="item">
            <span class="title">订单来源</span>
            <span class="value">{{
                order.channelAlias | filterConst("CHANNELALIAS")
              }}</span>
          </div>
          <div class="item">
            <span class="title">班次</span>
            <span class="value">{{ order.schedulingTime | filterTime("MM-DD") }}
              {{ order.startLineTime }} - {{ order.endLineTime }}
            </span>
          </div>
          <div class="item">
            <span class="title">实付金额</span>
            <template v-if="order.realFee || order.realFee === 0">
              <span class="util-money">￥{{ order.realFee }}</span>
              <span v-if="order.couponFee">
                (优惠券<span class="util-money-minus">-{{ order.couponFee }}</span>)</span>
            </template>
            <span class="value" v-if="!order.realFee && order.realFee !== 0">-</span>
          </div>
          <div class="item">
            <span class="title">机构名称</span>
            <span class="value">{{ order.organizationName }}</span>
          </div>
          <div class="item">
            <span class="title">联系人信息</span>
            <span class="value">{{ order.customerName }} / {{ order.customerPhone }}</span>
          </div>
          <div class="item">
            <span class="title">退改金额</span>
            <span v-if="order.retreatFee == null && order.isTicketChanging == 0" class="value"
                  style="color: #999; font-weight: bold">-
            </span>
            <span v-if="order.status === 60">
              <span class="util-money" v-if="order.retreatFee || order.retreatFee === 0">￥{{ order.retreatFee }}</span>
              <span class="util-money" v-if="!order.retreatFee && order.retreatFee !== 0">￥0</span>
              <template v-if="order.refundType == 2">
                (平台操作)
                {{ order.retreatFee ? "" : "(无退票费)" }}
              </template>
              <template v-if="order.refundType != 2">
                {{ order.refundProportion ? "(" + order.refundProportion + "%退票费率" + ")" : "(无退票费)" }}
              </template>
            </span>

            <span v-if="order.isTicketChanging === 1">
              <span class="util-money" v-if="order.ticketChangingFee || order.ticketChangingFee === 0">￥{{
                  order.ticketChangingFee
                }}
              </span>
              <span class="util-money" v-if="!order.ticketChangingFee && order.ticketChangingFee !== 0">￥0
              </span>
              {{
                order.ticketChangingProportion
                    ? "(" + order.ticketChangingProportion + "%改签费率" + ")"
                    : "(无改签费)"
              }}
            </span>
          </div>
          <div class="item">
            <span class="title">车辆信息</span>
            <span v-if="order.licenseNo" :style="getPlateStyle(order.licenseNo)">{{ formatPlateNumber(order.licenseNo) }}</span>
            <span v-else class="value">-</span>
          </div>

          <div class="item">
            <span class="title">下单时间</span>
            <span class="value">{{ order.created | filterTime }}</span>
          </div>
          <div class="item">
            <span class="title">上车地点</span>
            <span class="value">{{ startStationName }}</span>
          </div>

          <div class="item">
            <span class="title">司机姓名</span>
            <span class="value">{{ order.driverName }}</span>
          </div>
          <div class="item">
            <span class="title">完成/取消时间</span>
            <span class="value">{{ order.finishTime | filterTime }}</span>
          </div>
          <div class="item">
            <span class="title">下车地点</span>
            <span class="value">{{ endStationName }}</span>
          </div>

          <div class="item">
            <span class="title">司机电话</span>
            <span class="value">{{ order.driverPhone }}</span>
          </div>

          <div class="item">
            <span class="title">评分</span>
            <el-rate v-model="order.score" disabled></el-rate>
            <!-- <span class="value" v-if="order.score">{{ order.score }}星</span>
            <span class="value" v-else></span> -->
          </div>
          <div class="item">
            <span class="title">评价内容</span>
            <span class="value">{{ order.evaluateDetail }}</span>
          </div>

          <div class="item">
            <span class="title" style="vertical-align: top">备注</span>
            <span class="value" style="display: inline-block;width: 80%;vertical-align: top;word-wrap: break-word;">
              {{ order.remark }}
            </span>
          </div>
        </div>


        <div class="formTitle">乘客信息 / {{ order.passengerNum }} 人</div>
        <el-table style="margin-bottom: 20px" border empty-text="暂无数据" :data="passengerList">
          <el-table-column prop="customerName" label="乘客姓名"/>
          <el-table-column prop="cardType" label="证件类型" v-slot="{row}">
            <span v-if="row.idCard">{{ row.cardType | fliterCardType }}</span>
            <span v-else>-</span>
          </el-table-column>
          <el-table-column prop="idCard" label="证件号码"></el-table-column>
          <el-table-column prop="customerPhone" label="乘客电话" v-slot="scope">
            {{ scope.row.customerPhone }}
            <el-popover v-if="scope.row.isDefault == 1" placement="top" v-model="visibleCustomerPhone"
                        @hide="customerPhone = null" @show="customerPhone = scope.row.customerPhone">
              <div style="display: flex;align-items: center;">
                <div class="redcheck">手机号码</div>
                <el-input v-model="customerPhone" style="width:120px;margin: 0 15px;" maxlength="11"
                          @input="customerPhone = customerPhone.replace(/[^\d]/g, '').replace(/^0/g, '')"/>
                <el-button type="primary" size="mini" :disabled="!customerPhone"
                           @click="setCustomerPhone(scope.row)">保存
                </el-button>
              </div>
              <el-button type="text" slot="reference">修改</el-button>
            </el-popover>
          </el-table-column>
          <el-table-column prop="seatNo" label="座位"/>
        </el-table>

        <div class="formTitle">改签记录</div>
        <el-table style="margin-bottom: 20px" border empty-text="暂无数据" :data="recordList">
          <el-table-column v-for="(item, index) in columns" :key="index" :prop="item.prop" :label="item.label">
            <template slot-scope="{ row }">
              <template v-if="item.prop === 'lineId'">
                {{ row.startStationName }}-{{ row.endStationName }}
              </template>
              <template v-else-if="item.prop === 'schedulingId'">
                {{ row.schedulingTime | filterTime("MM-DD") }}
                {{ row.startLineTime }}-{{ row.endLineTime }}
              </template>
              <template v-else-if="item.prop === 'created'">
                {{ row.created | filterTime }}
              </template>
              <template v-else>{{
                  row[item.prop] ? row[item.prop] : "-"
                }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 跟踪记录 -->
      <el-tab-pane name="flow">
        <template slot="label"><i class="el-icon-time" style="margin-right:4px"></i>跟踪记录</template>
        <custom-table
            ref="customTable"
            :customOptions="customOptions"
            :columns="flowColumns"
            labelWidth="135"
            :refreshShow="false"
            style="height: calc(100vh - 102px)"
            :paging="false"
        >
          <template slot-scope="{ item, row }">
            <template v-if="item.prop == 'created'">
              <span> {{ row[item.prop] | filterTime }} </span>
            </template>
            <template v-else>
              <span> {{ row[item.prop] || '-' }} </span>
            </template>
          </template>
        </custom-table>
      </el-tab-pane>
      <el-tab-pane name="map">
        <template slot="label"><i class="el-icon-map-location" style="margin-right:4px"></i>地图查看</template>
        <div>
          <div class="box">
            <div class="item">
              <span class="title">上车地点</span>
              <span class="value">{{ order.startStationName }}</span>
            </div>

            <div class="item">
              <span class="title">出发时间</span>
              <span class="value">{{ order.schedulingTime | filterTime }}</span>
            </div>
            <div class="item">
              <span class="title">到达时间</span>
              <span class="value">{{ order.finishTime | filterTime }}</span>
            </div>

          </div>
          <div class="box">
            <div class="item">
              <span class="title">下车地点</span>
              <span class="value">{{ order.endStationName }}</span>
            </div>
            <div class="item">
              <span class="title">行程用时</span>
              <span class="value">{{ getTravelDuration() }}</span>
            </div>


          </div>
          <div id="order-map"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="order.status === 45" label="行程录音" name="audio">
        <div>
          <div class="box">
            <div class="item">
              <span class="title">上车地点</span>
              <span class="value">{{ order.startStationName }}</span>
            </div>

            <div class="item">
              <span class="title">出发时间</span>
              <span class="value">{{ order.schedulingTime | filterTime }}</span>
            </div>
            <div class="item">
              <span class="title">到达时间</span>
              <span class="value">{{ order.finishTime | filterTime }}</span>
            </div>

          </div>
          <div class="box">
            <div class="item">
              <span class="title">下车地点</span>
              <span class="value">{{ order.endStationName }}</span>
            </div>
            <div class="item">
              <span class="title">行程用时</span>
              <span class="value">{{ getTravelDuration() }}</span>
            </div>
            <div class="item">
              <span class="title">录音数量</span>
              <span class="value">{{ audioList.length }}条</span>
            </div>
          </div>

          <!-- 录音卡片列表 -->
          <div class="audio-section">
            <div class="formTitle">录音文件</div>
            <div v-if="audioList.length === 0" class="empty-audio">
              <span>暂无录音文件</span>
            </div>
            <div v-else class="audio-cards">
              <div
                  v-for="(audio, index) in audioList"
                  :key="audio.id"
                  class="audio-card"
              >
                <div class="audio-card-header">
                  <div class="audio-info">
                    <h4 class="audio-title">录音文件 #{{ index + 1 }}</h4>
                    <p class="audio-id">ID: {{ audio.soundRecordId }}</p>
                  </div>
                  <div class="audio-duration">
                    <span class="duration-text">{{ getAudioDuration(audio) }}</span>
                  </div>
                </div>

                <div class="audio-time-info">
                  <div class="time-item">
                    <span class="time-label">录制时间:</span>
                    <span class="time-value">
                      {{ audio.startTime | filterTime }}
                      -
                      {{ audio.endTime | filterTime('HH:mm:SS') }}
                    </span>
                  </div>
                  <!--                  <div class="time-item">-->
                  <!--                    <span class="time-label">结束时间:</span>-->
                  <!--                    <span class="time-value">{{ audio.endTime | filterTime }}</span>-->
                  <!--                  </div>-->
                </div>

                <div class="audio-player">
                  <audio
                      :ref="'audio_' + audio.id"
                      :src="getAudioUrl(audio.recordUrl)"
                      @loadedmetadata="onAudioLoaded"
                      @timeupdate="onTimeUpdate(audio.id, $event)"
                      @ended="onAudioEnded(audio.id)"
                      preload="metadata"
                  ></audio>

                  <div class="player-controls">
                    <div class="control-top">
                      <div class="button-group">
                        <el-button
                            :type="currentPlayingId === audio.id ? 'danger' : 'primary'"
                            size="small"
                            :icon="currentPlayingId === audio.id ? 'el-icon-video-pause' : 'el-icon-video-play'"
                            @click="toggleAudioPlay(audio)"
                        >
                          {{ currentPlayingId === audio.id ? '暂停' : '播放' }}
                        </el-button>

                        <el-button
                            type="success"
                            size="small"
                            icon="el-icon-download"
                            @click="downloadAudio(audio)"
                        >
                          下载
                        </el-button>
                      </div>

                      <div class="progress-bar">
                        <el-progress
                            :percentage="getPlayProgress(audio.id)"
                            :show-text="false"
                            :stroke-width="6"
                        ></el-progress>
                      </div>
                    </div>

                    <div class="time-display">
                      {{ formatCurrentTime(audio.id) }} / {{ formatTotalTime(audio.id) }}
                    </div>
                  </div>
                </div>

                <div class="audio-meta">
                  <div class="meta-item">
                    <span class="meta-label">创建时间:</span>
                    <span class="meta-value">{{ audio.created | filterTime }}</span>
                  </div>
                  <div class="meta-item" v-if="audio.organizationName">
                    <span class="meta-label">机构名称:</span>
                    <span class="meta-value">{{ audio.organizationName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
import AMap from "AMap";

export default {
  name: "orderDetails",
  props: {
    visible: {
      // 显隐
      default() {
        return false;
      },
    },
    order: {
      // 订单
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tabAction: "order",
      lineInfo: null,
      map: null,
      markerBegin: null,
      markerEnd: null,
      routePolyline: null, // 行车路线
      vis: false,
      columns: [
        {prop: "lineId", label: "原线路"},
        {prop: "schedulingId", label: "原班次"},
        {prop: "created", label: "改签时间"},
      ],
      recordList: [],
      startStationName: null,
      endStationName: null,
      passengerList: [],

      visibleCustomerPhone: false,
      customerPhone: null,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/status",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 50, // 每页条数
        },
        search: []
      },
      // 表头
      flowColumns: [
        {prop: "remark", label: "记录内容", minWidth: 280},
        {prop: "operator", label: "操作人", minWidth: 150},
        {prop: "created", label: "记录时间", minWidth: 130},
      ],
      audioList: [],
      // 录音播放相关状态
      currentPlayingId: null, // 当前播放的录音ID
      audioProgress: {}, // 存储每个录音的播放进度
      audioDuration: {}, // 存储每个录音的总时长
    };
  },
  mounted() {
    console.log(this.order, 111)
    this.customOptions.params.orderId = this.order.id;
  },
  watch: {
    visible(val) {
      this.vis = val;
    },
    vis(val) {
      this.$emit("update:visible", val);
      if (!val) {
        this.tabAction = "order";
        this.audioList = []
        this.map.remove(this.routePolyline);
      }
    },
    order: {
      handler(val) {
        if (val) {
          this.loadChildren(val);
          this.record(val);
          this.address(val);
          this.customOptions.params.orderId = val.id;
          this.$nextTick(() => {
            this.$refs.customTable.listFn();
          })
        }
      },
      deep: true,
    },
    async tabAction(val) {
      if (val == "map") {
        if (!this.map) {
          await this.initMap();
        }

        await this.drawOrderMarker();
        if(this.order.status === 45){
          await this.lineInit()
        }

      }
      console.log(444, val);
      if (val == "audio") {
        this.getAudioInitFn()
      }
    },
  },
  methods: {

    // 地图初始化
    initMap() {
      this.map = new AMap.Map("order-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });


    },

    async lineInit(val) {
      const url = "/api/v1/manage/order/location"
      const {code, data} = await this.$axios.get(url, {
        id: this.order.id
      });

      // 绘制GPS轨迹路线
      if (code === 1 && data && data.length > 0) {
        this.drawSimpleRoute(data);
      }
    },

    /**
     * 绘制简单的GPS轨迹路线
     * @param {Array} trackData GPS轨迹点数据
     */
    drawSimpleRoute(trackData) {
      if (!this.map || !trackData || trackData.length === 0) {
        return;
      }

      // 清除之前的路线
      if (this.routePolyline) {
        this.map.remove(this.routePolyline);
      }

      // 转换GPS轨迹点为高德地图坐标格式
      const path = trackData.map(point => [point.longitude, point.latitude]);

      // 创建轨迹路线
      this.routePolyline = new AMap.Polyline({
        path: path,
        strokeColor: '#2B77FF', // 蓝色路线
        strokeWeight: 10, // 线条宽度
        strokeOpacity: 0.8, // 透明度
        strokeStyle: 'solid', // 实线
        showDir:true,
        lineJoin: 'round',
        lineCap: 'round',
        zIndex: 50
      });

      // 添加路线到地图
      this.map.add(this.routePolyline);

      // 自动调整地图视野显示完整路线
      this.map.setFitView([this.routePolyline, this.markerEnd, this.markerBegin]);
    },

    async getAudioInitFn() {
      const url = "/api/v1/manage/order/scheduling/sound/record/" + this.order.orderDriverId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.audioList = data.data;
      }
    },

    // 乘客信息
    async loadChildren(val) {
      let url = "/api/v1/manage/order/orderCustomer/customer/" + val.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data?.length > 0) {
        this.passengerList = data.data;
      } else {
        this.$message.error("乘客信息查询错误");
      }
    },

    /* 修改联系人电话 */
    async setCustomerPhone(row) {
      if (this.customerPhone.length != 11) {
        this.$message.info("请输入11位手机号");
        return;
      }
      let url = "/api/v1/manage/order/orderCustomer/updateCustomerPhone";
      let params = {
        orderId: this.order.id,
        customerPhone: this.customerPhone
      }
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("已修改");
        row.customerPhone = this.customerPhone;
        this.order.customerPhone = this.customerPhone;
        this.visibleCustomerPhone = false;
      } else {
        this.$message.warning("修改失败");
      }
    },

    // 改签记录
    async record(val) {
      let params = {
        id: val.id,
      };
      let url = "/api/v1/manage/order/ticketChanging/record";
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.recordList = data.data;
      }
    },

    // 上下车地点
    async address(val) {
      let url = "/api/v1/manage/order/address/" + val.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.startStationName =
            data.data[0].address || "" + " " + data.data[0].name;
        this.endStationName =
            data.data[1].address || "" + " " + data.data[1].name;
        this.lineInfo = data.data || [];
        this.drawOrderMarker();
      }
    },

    /* 订单marker */
    drawOrderMarker() {
      if (this.tabAction != "map") {
        return;
      }
      let begin = this.lineInfo[0];
      let end = this.lineInfo[1];
      let beginContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;

                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #4dace2;">
                                <div>上车地点：${begin.name}</div>
                            </div>`;
      let endContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;

                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #47c147;">
                                <div>下车地点：${end.name}</div>
                          </div>`;
      if (this.markerBegin) {
        this.markerBegin.setMap(null);
        this.markerEnd.setMap(null);
      }
      this.markerBegin = new AMap.Marker({
        position: new AMap.LngLat(begin.longitude, begin.latitude),
        icon: require("@/assets/img/markerBegin.png"),
        map: this.map,
      });
      this.markerBegin.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: beginContent,
        direction: "top",
      });

      this.markerEnd = new AMap.Marker({
        position: new AMap.LngLat(end.longitude, end.latitude),
        icon: require("@/assets/img/markerEnd.png"),
        map: this.map,
      });
      this.markerEnd.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: endContent,
        direction: "top",
      });

      this.$nextTick(() => {
        this.map.setFitView();
      });
    },

    /**
     * 计算行程用时
     */
    getTravelDuration() {
      // 判空处理
      if (!this.order || !this.order.schedulingTime || !this.order.finishTime) {
        return '-';
      }

      const startTime = new Date(this.order.schedulingTime);
      const endTime = new Date(this.order.finishTime);

      // 验证日期是否有效
      if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
        return '-';
      }

      // 计算时间差（毫秒）
      const timeDiff = endTime.getTime() - startTime.getTime();

      // 如果时间差为负数或零，返回默认值
      if (timeDiff <= 0) {
        return '-';
      }

      // 转换为小时和分钟
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

      // 格式化输出
      if (hours > 0) {
        return minutes > 0 ? `${hours}小时${minutes}分钟` : `${hours}小时`;
      } else {
        return minutes > 0 ? `${minutes}分钟` : '-';
      }
    },

    /**
     * 计算录音时长
     * @param {Object} audio 录音对象
     * @return {String} 格式化的时长字符串
     */
    getAudioDuration(audio) {
      if (!audio || !audio.startTime || !audio.endTime) {
        return '-';
      }

      // startTime 和 endTime 是时间戳（秒）
      const startTime = new Date(audio.startTime * 1000);
      const endTime = new Date(audio.endTime * 1000);

      // 验证日期是否有效
      if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
        return '-';
      }

      // 计算时间差（毫秒）
      const timeDiff = endTime.getTime() - startTime.getTime();

      if (timeDiff <= 0) {
        return '-';
      }

      // 转换为分钟和秒
      const totalSeconds = Math.floor(timeDiff / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },

    /**
     * 获取录音文件URL
     * @param {String} recordUrl 录音文件标识
     * @return {String} 完整的录音文件URL
     */
    getAudioUrl(recordUrl) {
      if (!recordUrl) {
        return '';
      }
      // 假设录音文件通过文件服务器提供，需要根据实际情况调整
      return `${window.configure.qiniuUrl}/${recordUrl}`;
    },

    /**
     * 切换录音播放/暂停
     * @param {Object} audio 录音对象
     */
    toggleAudioPlay(audio) {
      const audioElement = this.$refs['audio_' + audio.id];
      if (!audioElement || !audioElement[0]) {
        this.$message.error('录音文件加载失败');
        return;
      }

      const audioEl = audioElement[0];

      // 如果当前有其他录音在播放，先暂停
      if (this.currentPlayingId && this.currentPlayingId !== audio.id) {
        const currentAudioElement = this.$refs['audio_' + this.currentPlayingId];
        if (currentAudioElement && currentAudioElement[0]) {
          currentAudioElement[0].pause();
        }
      }

      // 切换播放状态
      if (this.currentPlayingId === audio.id) {
        // 当前正在播放，暂停
        audioEl.pause();
        this.currentPlayingId = null;
      } else {
        // 开始播放
        audioEl.play().then(() => {
          this.currentPlayingId = audio.id;
        }).catch(error => {
          console.error('录音播放失败:', error);
          this.$message.error('录音播放失败');
        });
      }
    },

    /**
     * 录音加载完成事件
     */
    onAudioLoaded() {
      // 可以在这里处理录音加载完成后的逻辑
    },

    /**
     * 录音播放进度更新
     * @param {Number} audioId 录音ID
     * @param {Event} event 时间更新事件
     */
    onTimeUpdate(audioId, event) {
      const audio = event.target;
      this.$set(this.audioProgress, audioId, {
        currentTime: audio.currentTime,
        duration: audio.duration
      });
    },

    /**
     * 录音播放结束
     * @param {Number} audioId 录音ID
     */
    onAudioEnded(audioId) {
      this.currentPlayingId = null;
      this.$set(this.audioProgress, audioId, {
        currentTime: 0,
        duration: this.audioProgress[audioId]?.duration || 0
      });
    },

    /**
     * 获取播放进度百分比
     * @param {Number} audioId 录音ID
     * @return {Number} 进度百分比
     */
    getPlayProgress(audioId) {
      const progress = this.audioProgress[audioId];
      if (!progress || !progress.duration) {
        return 0;
      }
      return Math.round((progress.currentTime / progress.duration) * 100);
    },

    /**
     * 格式化当前播放时间
     * @param {Number} audioId 录音ID
     * @return {String} 格式化的时间字符串
     */
    formatCurrentTime(audioId) {
      const progress = this.audioProgress[audioId];
      if (!progress) {
        return '00:00';
      }
      return this.formatTime(progress.currentTime || 0);
    },

    /**
     * 格式化总时长
     * @param {Number} audioId 录音ID
     * @return {String} 格式化的时间字符串
     */
    formatTotalTime(audioId) {
      const progress = this.audioProgress[audioId];
      if (!progress) {
        return '00:00';
      }
      return this.formatTime(progress.duration || 0);
    },

    /**
     * 时间格式化工具方法
     * @param {Number} seconds 秒数
     * @return {String} 格式化的时间字符串 (mm:ss)
     */
    formatTime(seconds) {
      if (isNaN(seconds) || seconds < 0) {
        return '00:00';
      }

      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },

    /**
     * 下载录音文件
     * @param {Object} audio 录音对象
     */
    /**
     * 下载录音文件
     * @param {Object} audio 录音对象
     */
    downloadAudio(audio) {
      if (!audio || !audio.recordUrl) {
        this.$message.error('录音文件不存在');
        return;
      }

      try {
        // 获取录音文件的完整URL
        const audioUrl = this.getAudioUrl(audio.recordUrl);

        // 生成文件名：录音文件_日期时间_录音ID.mp3
        const startTimeStr = this.$options.filters.filterTime(audio.startTime, 'YYYY-MM-DD_HH-mm-SS');
        const fileName = `录音文件_${startTimeStr}_${audio.soundRecordId}.mp3`;

        // 使用 blob 方式下载，确保文件名生效
        fetch(audioUrl)
            .then(response => response.blob())
            .then(blob => {
              const blobUrl = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = fileName;  // 确保文件名正确设置
              link.style.display = 'none';

              // 触发下载
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              // 清理创建的 URL 对象
              window.URL.revokeObjectURL(blobUrl);

              this.$message.success('录音文件下载已开始');
            })
            .catch(error => {
              console.error('录音下载失败:', error);
              this.$message.error('录音下载失败，请稍后重试');
            });

      } catch (error) {
        console.error('录音下载失败:', error);
        this.$message.error('录音下载失败，请稍后重试');
      }
    }

  },
};
</script>

<style lang="less" scoped>
#orderDetails {
  /deep/ .el-drawer {
    width: 70% !important;
    overflow-x: hidden;
  }

  .formTitle {
    margin-top: 50px;
  }

  #order-map {
    width: 100%;
    height: 840px;
  }

  .el-col {
    margin: 15px 0;
  }

  .box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .item {
      display: flex;
      width: 33%;
      margin: 15px 0;
      font-size: 14px;

      .title {
        flex-shrink: 0;
        display: inline-block;
        width: 100px;
        margin-right: 20px;
        text-align: right;
      }

      .value {
        word-wrap: break-word;
        color: #999;

        &:empty {
          &::after {
            content: "-";
            color: rgb(233, 233, 233);
          }
        }
      }
    }
  }

  // 录音卡片样式
  .audio-section {
    margin-top: 30px;

    .empty-audio {
      text-align: center;
      color: #999;
      padding: 40px 0;
      font-size: 14px;
    }

    .audio-cards {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
    }

    .audio-card {
      flex: 0 1 calc(33.333% - 14px); // 一排显示3个卡片，减去gap的影响
      min-width: 300px; // 最小宽度保证内容完整显示
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      padding: 20px;
      background: #fafafa;
      transition: all 0.3s ease;
      box-sizing: border-box;

      // 响应式设计 - 中等屏幕（平板）
      @media (max-width: 1200px) {
        flex: 0 1 calc(50% - 10px); // 一排显示2个卡片
      }

      // 响应式设计 - 小屏幕（手机）
      @media (max-width: 768px) {
        flex: 0 1 100%; // 一排显示1个卡片
        min-width: unset;
      }

      &:hover {
        border-color: #2B77FF;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
      }

      .audio-card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 15px;

        .audio-info {
          .audio-title {
            margin: 0 0 5px 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
          }

          .audio-id {
            margin: 0;
            font-size: 12px;
            color: #999;
            font-family: 'Courier New', monospace;
          }
        }

        .audio-duration {
          .duration-text {
            background: #2B77FF;
            color: white;
            padding: 4px 12px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
          }
        }
      }

      .audio-time-info {
        display: flex;
        gap: 20px;
        margin-bottom: 15px;
        padding: 10px;
        background: #f0f9ff;
        border-radius: 6px;
        flex-wrap: wrap;

        .time-item {
          display: flex;
          align-items: center;
          font-size: 13px;
          flex: 1;
          min-width: 120px;

          .time-label {
            color: #666;
            margin-right: 8px;
            font-weight: 500;
          }

          .time-value {
            color: #333;
            font-family: 'Courier New', monospace;
          }
        }

        // 响应式设计 - 小屏幕下垂直排列
        @media (max-width: 768px) {
          flex-direction: column;
          gap: 8px;

          .time-item {
            min-width: unset;
          }
        }
      }

      .audio-player {
        margin-bottom: 15px;

        .player-controls {
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 15px;
          background: white;
          border-radius: 6px;
          border: 1px solid #e6e6e6;

          .control-top {
            display: flex;
            align-items: center;
            gap: 15px;

            .button-group {
              display: flex;
              gap: 8px;
              align-items: center;
              flex-shrink: 0;

              // 响应式设计 - 小屏幕下按钮更紧凑
              @media (max-width: 768px) {
                gap: 6px;

                /deep/ .el-button {
                  padding: 7px 10px;
                  font-size: 12px;
                }
              }
            }

            .progress-bar {
              flex: 1;
            }
          }

          .time-display {
            font-size: 12px;
            color: #666;
            font-family: 'Courier New', monospace;
            text-align: center;
            padding-top: 5px;
          }
        }
      }

      .audio-meta {
        display: flex;
        gap: 20px;
        padding-top: 10px;
        border-top: 1px solid #e6e6e6;
        flex-wrap: wrap;

        .meta-item {
          display: flex;
          align-items: center;
          font-size: 13px;
          flex: 1;
          min-width: 150px;

          .meta-label {
            color: #666;
            margin-right: 8px;
            font-weight: 500;
          }

          .meta-value {
            color: #333;
          }
        }

        // 响应式设计 - 小屏幕下垂直排列
        @media (max-width: 768px) {
          flex-direction: column;
          gap: 8px;

          .meta-item {
            min-width: unset;
          }
        }
      }
    }
  }
}
</style>
